import { Autocomplete, TextField } from '@mui/material';
import React, { Dispatch, FC, SetStateAction, useState } from 'react';

import { ShopType } from '../types/shop';

export interface ProductSizeSelectorProps {
  shops: ShopType[];
  onSelect: Dispatch<SetStateAction<ShopType | undefined>>;
  error: boolean;
  initValue?: ShopType;
}

const ShopSelector: FC<ProductSizeSelectorProps> = ({
  shops,
  onSelect,
  error,
  initValue,
}) => {
  const [selectedShop, setSelectedShop] = useState<ShopType | undefined>(
    initValue,
  );

  const handleShopSelect = (_event: any, value: ShopType) => {
    setSelectedShop(value);
    onSelect(value);
  };

  return (
    <Autocomplete
      options={shops}
      getOptionLabel={(option) =>
        `${option.city}, ${option.street} ${option.buildingNumber} ${
          option.apartmentNumber && `/${option.apartmentNumber}`
        }`
      }
      value={selectedShop}
      onChange={handleShopSelect}
      noOptionsText="Brak sklepów do wyboru"
      disableClearable
      renderInput={(params) => (
        <TextField
          {...params}
          label={selectedShop ? 'Sklep odbioru' : 'Wybierz sklep'}
          variant="outlined"
          helperText={error ? 'Wybierz sklep do odbioru zamówienia' : ''}
          error={error}
        />
      )}
    />
  );
};

export default ShopSelector;
